<template>
    <div>
        <vue-headful
                title="Falk Huth | Kontakt"
                description="Kontakt zu Falk Huth aufnehmen"
        />
        <form novalidate class="md-layout" @submit.prevent="validateUser">
            <md-card md-with-hover class="volle-breite">
                <md-ripple>
                    <md-card-header>
                        <div class="md-title">Kontakt</div>
                    </md-card-header>

                    <md-card-content>

                        <div class="md-layout md-gutter md-size-100">
                            <div class="md-layout-item md-size-100">

                                <md-field :class="getValidationClass('fullname')" class="md-required">
                                    <md-icon :class="getIconClass('fullname')">person</md-icon>
                                    <label for="fullname">Name</label>
                                    <md-input name="fullname" id="fullname" autocomplete="fullname" v-model="form.fullname"
                                              @blur="$v.form.fullname.$touch()" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.fullname.required">Der Name muss angegeben werden.</span>
                                </md-field>

                            </div>
                        </div>

                        <div class="md-layout md-gutter md-size-100">
                            <div class="md-layout-item md-size-50 md-xsmall-size-100">

                                <md-field :class="getValidationClass('handy')">
                                    <md-icon :class="getIconClass('handy')">smartphone</md-icon>
                                    <label for="handy">Handy</label>
                                    <md-input name="handy" id="handy" autocomplete="handy" v-model="form.handy"
                                              @blur="$v.form.handy.$touch()" :disabled="sending" />
                                </md-field>

                            </div>
                            <div class="md-layout-item md-size-50 md-xsmall-size-100">

                                <md-field :class="getValidationClass('phone')">
                                    <md-icon :class="getIconClass('phone')">phone</md-icon>
                                    <label for="phone">Telefon</label>
                                    <md-input name="phone" id="phone" autocomplete="phone" v-model="form.phone"
                                              @blur="$v.form.phone.$touch()" :disabled="sending" />
                                </md-field>

                            </div>
                        </div>

                        <div class="md-layout md-gutter md-size-100">
                            <div class="md-layout-item md-size-100">

                                <md-field :class="getValidationClass('email')" class="md-required">
                                    <md-icon :class="getIconClass('email')">email</md-icon>
                                    <label for="email">E-Mail</label>
                                    <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email"
                                              @blur="$v.form.email.$touch()" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.email.required">Die E-Mail-Adresse muss angegeben werden.</span>
                                    <span class="md-error" v-else-if="!$v.form.email.email">Die E-Mail-Adresse ist ungültig.</span>
                                </md-field>

                            </div>
                        </div>

                        <div class="md-layout md-gutter md-size-100">
                            <div class="md-layout-item md-size-100" >

                                <md-field :class="getValidationClass('subject')" class="md-required">
                                    <md-icon :class="getIconClass('subject')">subject</md-icon>
                                    <label for="subject">Betreff</label>
                                    <md-input name="subject" id="subject" autocomplete="subject" v-model="form.subject"
                                              @blur="$v.form.subject.$touch()" :disabled="sending" />
                                    <span class="md-error" v-if="!$v.form.subject.required">Der Betreff muss angegeben werden.</span>
                                </md-field>

                            </div>
                        </div>

                        <md-field :class="getValidationClass('message')" class="md-required" >
                            <md-icon :class="getIconClass('message')">message</md-icon>
                            <label for="message">Nachricht</label>
                            <md-textarea name="message" id="message" autocomplete="message" v-model="form.message"
                                         @blur="$v.form.message.$touch()" :disabled="sending" />
                            <span class="md-error" v-if="!$v.form.message.required">Es muss eine Nachricht eingegeben werden.</span>
                            <span class="md-error" v-else-if="!$v.form.message.illegalChars">Die Nachricht ist ungültig.</span>
                        </md-field>

                        <div class="md-layout md-gutter md-size-100">
                            <div class="md-layout-item md-size-100">

                                <div class="md-body-1">
                                    Die Daten, die Sie hier in dem Kontaktformular eingeben werden per E-Mail an die
                                    Ponderosa Software gesendet und nicht anderweitig gespeichert. Deine Daten gibt
                                    die Ponderosa Software nur weiter, wenn Sie es so wünschen (z.B. um Details zu
                                    Ihrem Anliegen zu klären) oder wenn es im Rahmen gesetzlicher Vorschriften
                                    erforderlich ist.
                                    Alternativ können Sie die Ponderosa Software auch direkt per E-Mail an
                                    info@falk-huth.de wenden. Nähere Informationen
                                    finden Sie unter &quot;<router-link to=""><span
                                        @click="showDatenschutz = true">Datenschutz</span></router-link>&quot;.
                                </div>
                                <div class="md-body-1">
                                    &nbsp;<br/>
                                    Erklären Sie sich damit einverstanden und möchten Sie die Daten senden?
                                </div>
                                <md-radio v-model="agreementDataProtection" name="agreementDataProtection" :value="true">Ja</md-radio>
                                <md-radio v-model="agreementDataProtection" name="agreementDataProtection" :value="false">Nein</md-radio>
                            </div>
                        </div>

                        <md-progress-bar md-mode="indeterminate" v-if="sending" />
                    </md-card-content>

                    <md-card-actions>
                        <md-button type="reset" class="md-accent" :disabled="sending">
                            <md-icon>clear_all</md-icon>
                            <span>Zurücksetzen</span>
                        </md-button>
                        <md-button type="submit" class="md-primary" :disabled="sending">
                            <md-icon>send</md-icon>
                            <span>Senden</span>
                        </md-button>
                    </md-card-actions>

                </md-ripple>
            </md-card>
            <md-dialog :md-active.sync="showDatenschutz">
                <md-dialog-title>Datenschutzerklärung nach der EU-DSGVO</md-dialog-title>
                <md-dialog-content>
                    <Datenschutz runMode="modal"></Datenschutz>
                    <vue-headful
                            title="Falk Huth | Kontakt"
                            description="Kontakt zu Falk Huth aufnehmen"
                    />
                </md-dialog-content>
                <md-dialog-actions>
                    <md-button class="md-primary" @click="showDatenschutz = false">Schließen</md-button>
                </md-dialog-actions>
            </md-dialog>
            <md-dialog-alert
                    :md-active.sync="showAgreementDialog"
                    md-title="Fehlende Einverständnis-Erklärung"
                    md-content="Die Daten können nur gesendet werden, wenn Sie sich mit den Datenschutzhinweisen einverstanden erklären."
                    md-confirm-text="Verstanden" />
            <md-snackbar :md-active.sync="userSaved">Die E-Mail von {{ lastUser }} wurde erfolgreich gesendet.</md-snackbar>
        </form>
        <ApiCall ref="ApiCall"></ApiCall>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import {
        required,
        email
    } from 'vuelidate/lib/validators'

    // Own components
    import ApiCall from '../common/ApiCall'
    import Datenschutz from '../pages/Datenschutz'

    export default {
        name: "Kontakt",
        mixins: [validationMixin],
        components: {
            ApiCall,
            Datenschutz
        },
        data: () => ({
            form: {
                fullname: null,
                phone: null,
                handy: null,
                email: null,
                subject: null,
                message: null
            },
            agreementDataProtection: false,
            showDatenschutz: false,
            showAgreementDialog: false,
            userSaved: false,
            sending: false,
            lastUser: null
        }),
        validations () {
            return {
                form: {
                    booking: {},
                    fullname: {
                        required
                    },
                    handy: {
                    },
                    phone: {
                    },
                    email: {
                        required,
                        email
                    },
                    subject: {
                        required
                    },
                    message: {
                        required
                    }
                }
            };
        },
        methods: {
            appendLeadingZeroes: function (n){
                if (n <= 9){
                    return "0" + n;
                }
                return n
            },
            formatDate: function (d) {
                if (d === null) {
                    return '';
                }
                return this.appendLeadingZeroes(d.getDate()) + "." + this.appendLeadingZeroes(d.getMonth() + 1) + "." + d.getFullYear()
            },
            getIconClass (fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-accent': field.$invalid && field.$dirty
                    }
                }
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]

                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            clearForm () {
                this.$v.$reset()
                this.form.fullname = null
                this.form.phone = null
                this.form.handy = null
                this.form.email = null
                this.form.subject = null
                this.form.message = null
                this.agreementDataProtection = false
            },
            saveUser: async function() {
                if (this.agreementDataProtection === true) {
                    this.sending = true
                    await this.$refs.ApiCall.sendContactForm(this.form)
                    if (this.$refs.ApiCall.responseStatus === 201) {
                        this.lastUser = this.form.fullname
                        this.userSaved = true
                        this.clearForm()
                    }
                    this.sending = false
                } else {
                    this.showAgreementDialog = true
                }
            },
            validateUser () {
                this.$v.$touch()

                if (!this.$v.$invalid) {
                    this.saveUser()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .md-progress-bar {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
    }
    .volle-breite {
        width: 100%;
    }
</style>
